import React, { Fragment, KeyboardEventHandler } from "react";
import clsx from "clsx";
import NominationHeader from "../common/NominationHeader";
import queryString from "query-string";
import { connect, Options } from "react-redux";
import { FC } from "react";
import { GeneralService } from "../../services/GeneralService";
import { last6Digits, toNominationNo } from "../../services/Helper";
import { Link, useParams } from "react-router-dom";
import { mergeStyles } from "office-ui-fabric-react";
import { mergeStyleSets } from "@fluentui/react";
import { State } from "../../store";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { MODALITY, WorkPacket } from "../../models/WorkPacket";
import * as ActivityLogStore from "../../store/ActivityLogsStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as WorkPacketStore from "../../store/WorkPacketStore";
import * as GeneralStore from "../../store/GeneralStore";
import * as SofViewStore from "../../store/SofViewStore";
import { SofView } from "../../models/SofView";
import { FontIcon } from "office-ui-fabric-react/lib/Icon";
import SofIcon from "../common/Icons";
import TruckNominationHeader from "../truck/TruckNominationHeader";

interface Option {
  readonly label: string;
  readonly value: string;
}

type IProps = ActivityLogStore.ActivityLogsState &
  WorkPacketStore.WorkPacketState &
  LineHandlingStore.LineHandlingState &
  SofViewStore.SofViewState &
  GeneralStore.GeneralState &
  typeof WorkPacketStore.actionCreators &
  typeof GeneralStore.actionCreators &
  typeof LineHandlingStore.actionCreators &
  typeof SofViewStore.actionCreators;

const panelRow = mergeStyles({
  display: "flex"
});
const headerTitle = mergeStyles({
  color: "#00447E",
  letterSpacing: "0.004em"
});
const classes = mergeStyleSets({
  packetList: {
    overflowX: "hidden",
    overflowY: "scroll",
    maxHeight: "calc(100vh - 250px)",
    padding: "0",
    marginRight: "1px"
  },
  viewButton: {
    width: "40px",
    height: "40px",
    borderRadius: "5px",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none"
      }
    }
  },
  addNew: {
    // width: "148px",
    height: "40px",
    paddingLeft: "24px",
    paddingRight: "24px",
    borderRadius: "4px",
    border: "1px solid #009FDF",
    backgroundColor: "#009FDF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none"
      }
    },
    color: "white"
  },
  contentTitle: {
    color: "#4C4C4C",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    margin: 0
  },
  flexEnd: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center"
  },
  flexColJustifyCenter: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: "18px"
  },
  dotIndicator: {
    width: "12px",
    height: "12px",
    borderRadius: "8px",
    marginRight: "5px",
    marginTop: "2px"
  },
  formFooter: {
    position: "absolute",
    bottom: 15,
    padding: 16,
    backgroundColor: "white",
    alignItems: "center"
  },
  formFooterInner: {
    maxWidth: 900,
    margin: "auto",
    // display: "flex",
    justifyContent: "space-between",
    width: "100%"
  },
  sendButton: {
    padding: "8px 36px",
    backgroundColor: "#009FDF",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2
  },
  sentButton: {
    padding: "8px 36px",
    backgroundColor: "#008000",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2
  },
  errorButton: {
    padding: "8px 36px",
    backgroundColor: "red",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2
  },
  formHeader: {
    gap: 8,
    padding: "0px 16px 16px 16px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "white"
  },
  formHeaderTitle: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "24px",
    letterSpacing: "0.005em",
    color: "#4C4C4C"
  },
  toolbarSeparator: {
    height: "40px",
    width: "1px",
    background: "#D8DFE6",
    margin: "0"
  },
  inputBox: {
    border: "1px solid #D8DFE6",
    width: "100%"
  },
  modalEmail: {
    width: "100%",
    height: "100%",
    border: "0",
    boxShadow: "0 0 1em rgb(0 0 0 /.3)"
  },
  modalContainer: {
    display: "flex",
    height: "91vh"
  },
  modalPdfPreviewContainer: {
    flex: 1
  },
  modalRightPanelContainer: {
    width: "25%"
  },
  modalComponent: {
    paddingRight: 16,
    paddingLeft: 16
  },
  modalSelectedItemWrapper: {
    paddingTop: 16,
    display: "flex",
    flexDirection: "column"
  },
  modalSelectedItem: {
    paddingLeft: 10
  },
  container: {
    background: "",
    height: "100%"
  },
  flexContainer: {
    display: "Flex",
    gap: "16px",
    padding: "0",
    flexWrap: "Wrap"
  },
  serviceTitle: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "20px",
    marginBottom: "4px",
    flex: "1"
  },
  serviceDesc: {
    color: "#4C4C4C",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "24px",
    letterSpacing: "0.07px",
    margin: 0
  },
  serviceIcon: {
    background: "#0F7F79",
    width: "64px",
    height: "64px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px"
  },
  headerRow: [
    panelRow,
    {
      alignItems: "center",
      padding: "6px 24px",
      background: "white",
      borderBottom: "1px solid #E2E6E8",
    }
  ],
  headerRowTextPane: [
    panelRow,
    {
      flexDirection: "column",
      flexGrow: 1,
      margin: "0 10px",
      paddingLeft: 10,
      borderLeft: "1px solid #E2E6E8"
    }
  ],
  headerTitle: [
    headerTitle,
    {
      fontSize: 16,
      lineHeight: "20px",
      fontWeight: "bold"
    }
  ]
});

const buttonIcon = mergeStyles({
  padding: "9px 10px",
  fontSize: 16,
  fontWeight: 500,
  height: 40,
  width: 40,
  justifyContent: "center",
  border: "1px solid #D8DFE6",
  borderRadius: "2px",
  display: "flex",
  alignItems: "center",
  color: "#4c4c4c",
  selectors: {
    [":active"]: {
      backgroundColor: "#008cc0"
    }
  }
});

export const ServicesGroup: FC<IProps> = (props: IProps) => {
  const { lineHandlingNo } = useParams() as any;
  const [workPackets, setWorkPackets] = useState<WorkPacket[]>([]);
  const [servicesGroups, setServicesGroups] = useState<Array<string>>([]);
  const [allWorkPacket, setAllWorkPacket] = useState<WorkPacket[]>([]);
  const [nominationNo, setNominationNo] = useState<string>();
  const [modality, setModality] = useState<MODALITY>("MARINE");
  const history = useHistory();

  const redirectToService = (group: string) => {
    if (allWorkPacket.filter((_grp: any) => _grp.group == group).length > 1) {
      history.push({
        pathname: `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/services/group/${group}`,
        state: {
          fromGroupPage: true,
          prevPath: history.location.pathname
        }
      });
    } else {
      let packet = allWorkPacket.filter((_grp: any) => _grp.group == group)[0];
      history.push({
        pathname: `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packet/${
          packet.id
        }${
          packet.nominationNo !== undefined
            ? `?nomination=${packet.nominationNo}`
            : ""
        }`,
        state: {
          fromGroupPage: true,
          prevPath: history.location.pathname
        }
      });
    }
  };

  useEffect(() => {
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const nominationno = q.nomination as string | undefined;
    if (history.location.pathname.indexOf("truck") > 0) {
      //props.setPageTitle("Truck Nomination");
      props.setSofView(SofView.WorkPacket);
      setModality("TRUCK");
    } else if (history.location.pathname.indexOf("rail") > 0) {
      //props.setPageTitle("Rail Nomination");
      props.setSofView(SofView.WorkPacket);
      setModality("RAIL");
    } else {
      setModality("MARINE");
      if (!props.lineHandling.result) {
        props.getLineHandling(
          lineHandlingNo,
          nominationno,
          false,
          false,
          () => {}
        );
      }
    }
  }, []);

  useEffect(() => {
    if (props.workPackets.result) {
      const wpService = new GeneralService(
        props.lineHandling.result,
        undefined,
        props.activityLogs.result,
        props.workPacketValues.result
      );
      let _list = [];
      for (const wp of props.workPackets.result) {
        if (wp.level === 1) {
          _list.push({ ...wp, displayName: wp.name });
        } else if (wp.level === 2 && props.lineHandling.result) {
          // for (const nom of props.lineHandling.result.nominations) {
          _list.push({
            ...wp,
            displayName: wp.name
            //nominationNo: nom.nominationNo,
          });
          // }
        }
      }
      let listOfGroups: Array<string> = [];
      _list.forEach((f) => {
        if (f.group) {
          if (props.isMarineProcessAdditionalServices) {
            listOfGroups.push(f.group);
          } else if (props.isMarineDeliveryTruckOnly) {
            if (f.group === "Delivery Truck") {
              listOfGroups.push(f.group);
            }
          } else {
            listOfGroups.push(f.group);
          }
        }
      });
      setAllWorkPacket(
        _list.filter(
          (f) =>
            f.workPacketType === 3 && wpService.checkConditions(f.conditions)
        )
      );
      setServicesGroups(
        listOfGroups.filter(
          (item: string, index: number) => listOfGroups.indexOf(item) == index
        )
      );
      setWorkPackets(
        _list.filter(
          (f) =>
            f.workPacketType === 2 && wpService.checkConditions(f.conditions)
        )
      );
    }
  }, [props.workPackets]);

  useEffect(() => {
    props.setSofView(SofView.WorkPacket);
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const nominationno = q.nomination as string | undefined;

    setNominationNo(nominationno);
    props.getWPValues(lineHandlingNo);

    if (props.workPackets.result && props.workPackets.result.length === 0) {
      props.getAllWorkPackets();
    }
    props.setSofView(SofView.AdditionalServices);
  }, []);

  return (
    <div>
      {history.location.pathname.indexOf("truck") > 0 ? (
        <Fragment>
          <div className="WorkPacketListWrapper">
            <div className={classes.headerRow}>
              <SofIcon iconname="Truck2" />
              <div className={classes.headerRowTextPane}>
                <span className={classes.headerTitle}>
                  {toNominationNo(lineHandlingNo)}
                </span>
              </div>
            </div>
          </div>
          <TruckNominationHeader {...props} />
        </Fragment>
      ) : (
        <NominationHeader />
      )}
      <div
        className="ms-Grid-row"
        style={{
          padding: "12px 24px",
          fontWeight: "bold",
          borderBottom: "1px solid #E2E6E8",
          borderTop: "1px solid #E2E6E8",
          margin: 0,
          color: "#7C7777",
          background: "white"
        }}
      >
        <div id="packet-scroll" dir="ltr">
          <div className="ms-Grid-col ms-md8" style={{ paddingLeft: 0 }}>
            <div
              className="d-flex"
              style={{
                alignItems: "center",
                gap: "18px"
              }}
            >
              <button
                className={classes.viewButton}
                onClick={() =>
                  history.push(
                    `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/services`
                  )
                }
              >
                <FontIcon iconName="back" />
              </button>
              <h4 className={classes.contentTitle}>Select Service</h4>
            </div>
          </div>
          <div className="ms-Grid-col ms-md4" style={{ padding: "0" }}>
            <div className={classes.flexEnd} style={{ gap: "8px" }}>
              <button
                className={classes.viewButton}
                onClick={() =>
                  history.push(
                    `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/services`
                  )
                }
              >
                <SofIcon iconname="CloseIcon" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: "", margin: "12px 24px", height: "100%" }}>
        <div className={classes.container}>
          <div className={classes.flexContainer}>
            {servicesGroups.map((group, index: number) => {
              return (
                <div
                  key={`add-service-${index}`}
                  className="serviceItem"
                  onClick={() => redirectToService(group)}
                >
                  {/* to={`/marine/${lineHandlingNo}/work-packet/${packet.id}${
                    packet.level === 2
                      ? `?nomination=${packet.nominationNo}`
                      : ""
                  }`} */}

                  <div className={classes.serviceIcon}>
                    <SofIcon
                      iconname={group.replace(/\s/g, "")}
                      style={{ width: 48, height: 48 }}
                    />
                  </div>
                  <div className={classes.flexColJustifyCenter}>
                    <h5 className={classes.serviceTitle}>{group}</h5>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default connect(
  (state: State) => ({
    ...state.workPacket,
    ...state.activityLogs,
    ...state.lineHandling,
    ...state.general,
    ...state.sofView
  }),
  {
    ...WorkPacketStore.actionCreators,
    ...GeneralStore.actionCreators,
    ...LineHandlingStore.actionCreators,
    ...SofViewStore.actionCreators
  }
)(ServicesGroup as any);
